<o-menu
  [menu]="menu"
  [roles]="authService.userRole()"
  (oLogout)="logout()"
  [logo]="'../../assets/Olameter-Logo.svg'"
  [env]="environment"
  [user]="user()"
  (oLanguageChange)="onLanguageChange($event)"
  [currentLanguage]="languageService.getCurrentLanguage()"
  [allowLanguageChange]="true"
  [allowUserMenu]="true"
  >
  <div class="app-container">
    <div class="app-header d-flex bg-secondary border py-2">
      <app-actions-ribbon
        [workOrders]="workOrders()"
        [selectedWorkOrders]="selectedWorkOrders()"
        [showItem]="showItem()"
        [columnsList]="columnsList()"
        [gridState]="gridState()"
        class="w-100 ps-3"
        [timezone]="timezone()"
      ></app-actions-ribbon>
    </div>
    <div class="app-body">
      <!-- WOs - pending state: show the big loader only until the first row arrives.
      Once streaming has produced any rows, hand off to the grid container
      below (which renders progressively) and let the actions-ribbon's inline
      indicator carry the "still loading" message. -->
      @if (
        _clientWO.success() === false &&
        _clientWO.pending()
        ) {
        <div
          class="d-flex workorders-loading"
          >
          <div class="d-grid">
            <div class="text-center mb-3">
              <kendo-loader [type]="'converging-spinner'"></kendo-loader>
            </div>
            @if ( _clientWO.loadedRowCount() === 0) {
              <div class="text-center">
                {{ 'HOME.LOADING_WORK_ORDERS' | translate }}
              </div>
            }
            @if ( _clientWO.loadedRowCount() > 0) {
              <div class="text-center">
                {{
                'HOME.STREAM.LOADING'
                | translate: { count: (_clientWO.loadedRowCount() | number) }
                }}
              </div>
            }
          </div>
        </div>
      }
      <!-- WOs - empty state -->
      @if (
        _clientWO.success() === true &&
        _clientWO.pending() === false &&
        _clientWO.streamingInProgress() === false &&
        _clientWO.getValue().length === 0
        ) {
        <div
          class="d-flex workorders-loading"
          >
          <div class="d-grid">
            <div class="text-center">{{ 'HOME.NO_RECORDS' | translate }}</div>
          </div>
        </div>
      }
      <!-- WOs - panelbar: visible as soon as any rows are available — either the
      stream is finished (`success`) or rows have started flowing in. -->
      @if (
        (_clientWO.success() || _clientWO.streamingInProgress()) &&
        workOrders()?.length > 0
        ) {
        <kendo-panelbar (itemClick)="onPanelMapCollapse($event)" [keepItemContent]="true">
          <kendo-panelbar-item class="" title="{{ 'HOME.MAPS' | translate }}" [expanded]="true">
            <ng-template kendoPanelBarContent>
              <app-workorders-map
                [gridStateMap]="gridStateMap()"
                [gridState]="gridState()"
                [columnsList]="columnsList()"
                [contractName]="contractName()"
                [startDateFilter]="startDateFilter()"
                [endDateFilter]="endDateFilter()"
                [installDateOption]="installDateOption()"
                [workOrders]="workOrders()"
                [selectMapTool]="selectMapTool()"
                [selectedWorkOrders]="selectedWorkOrders()"
                (updateWOSelection)="updateWOSelection($event)"
                [gridData]="gridData()"
              ></app-workorders-map>
            </ng-template>
          </kendo-panelbar-item>
        </kendo-panelbar>
        <kendo-panelbar>
          <kendo-panelbar-item
            title="{{ 'HOME.DISPATCH_DATA' | translate }}"
            [expanded]="_clientWO.exportOpenGridPanel()"
            >
            <ng-template kendoPanelBarContent>
              <app-kendo-grid
                [selectedWorkOrders]="selectedWorkOrders()"
                [workOrders]="workOrders()"
                [gridState]="gridState()"
                [showItem]="showItem()"
                [columnsList]="columnsList()"
                (updateState)="updateGridState($event)"
                (updateLocalState)="updatLocalGridState($event)"
                (updateWOSelection)="updateWOSelection($event)"
                (updateColumnsList)="updateColumnsList($event)"
                (updateShowItem)="updateShowItem($event)"
                (clearFilters)="clearFilters()"
                [pending]="_clientWO.gridPending()"
                [pageHeight]="pageHeight()"
                [gridData]="gridData()"
                [selectedSet]="selectedSet()"
                [timezone]="timezone()"
              ></app-kendo-grid>
            </ng-template>
          </kendo-panelbar-item>
        </kendo-panelbar>
        <kendo-panelbar>
          <kendo-panelbar-item title="{{ 'HOME.DATA_PIVOT_TABLE' | translate }}" [expanded]="false">
            <ng-template kendoPanelBarContent>
              <app-ag-grid
                [selectedWorkOrders]="selectedWorkOrders()"
                [workOrders]="workOrders()"
                [columnsList]="columnsList()"
                (updateWOSelection)="updateWOSelection($event)"
                (updateState)="updateGridState($event)"
                [gridState]="gridState()"
                [readOnlyMode]="authService.readOnlyMode()"
                (updateColumnsList)="updateColumnsList($event)"
                [pending]="_clientWO.gridPending()"
              ></app-ag-grid>
            </ng-template>
          </kendo-panelbar-item>
        </kendo-panelbar>
        <kendo-panelbar>
          <kendo-panelbar-item title="{{ 'HOME.DASHBOARD_AND_REPORTS' | translate }}" [expanded]="false">
            <ng-template kendoPanelBarContent>
              <div class="wo-status-container">
                <div class="row">
                  <div class="col">
                    <div
                      class="wo-status-items mb-3 mt-2 text-start small ps-4"
                      >
                      {{ 'HOME.DASHBOARD_PLACEHOLDER' | translate }}
                      <!-- TODO Dashboard and Reports will appear here -->
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </kendo-panelbar-item>
        </kendo-panelbar>
      }
    </div>
  </div>
</o-menu>
